import {
  QueryClient,
  QueryClientConfig,
  QueryClientProvider,
} from '@tanstack/react-query';

const defaultConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 3,
      refetchOnWindowFocus: true,
    },
  },
};

export const queryClient = new QueryClient(defaultConfig);

export const createQueryClient = (options?: QueryClientConfig) => {
  return new QueryClient(options || defaultConfig);
};

export { QueryClientProvider };
